<template>
  <div class="container py-4">
    <div class="container px-md-5">
      <div class="row form-wrapper d-flex flex-column">
        <h1>About</h1>
        <p>
          <strong>About the Registration Data Access Protocol (RDAP)</strong>
        </p>
        <p>The Registration Data Access Protocol (RDAP) is an alternative to WHOIS for accessing Internet resource registration data. RDAP is designed to address a number of shortcomings in the existing Whois service. The most important changes are:</p>
        <ul>
          <li>Standardization of queries and responses</li>
          <li>Internationalization considerations to cater for languages other than English in data objects</li>
          <li>Redirection capabilities to allow seamless referrals to other registries</li>
        </ul>
        <p>RDAP’s standardized query format means that clients only need to learn one way to ask a registry about its data, while the standardized response format, so clients only need to learn how to parse a response once.</p>
        <p>
          It uses common technologies to deliver service, so tool developers can leverage existing libraries and frameworks. And it supports internationalization, so data is no longer presented in a random character set, but instead always in
          UTF-8.
        </p>
        <p>It supports redirection, so querying APNIC for an ARIN address will redirect to ARIN’s service, and vice versa.</p>
        <p>
          Read more about the origin and reasons behind this work and the history of whois in the APNIC News article,
          <a
            href="https://archive.apnic.net/news-archives/2012/future-whois/"
            target="_blank"
            rel="noreferrer"
          >The Future of WHOIS</a>.
        </p>
        <p>
          You can find out more about RDAP
          <a
            href="https://www.apnic.net/about-apnic/whois_search/about/rdap/"
            target="_blank"
            rel="noreferrer"
          >here</a>.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
</style>
